import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";
import {
  ExpenseBreakdown,
  FinanceSummary,
  ReceivablesReport,
  VehicleFinanceRow,
} from "./types";

/**
 * `DateRange` iz dashboard konteksta ima `from`/`to` kao `Date | null` — preset "sve"
 * ih ostavlja praznima, a backend tada sam razrješava raspon.
 */
const buildRangeParams = (from?: Date | null, to?: Date | null): string => {
  const asParam = (date: Date): string =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate()
    ).padStart(2, "0")}`;

  const parts: string[] = [];
  if (from) parts.push(`from=${asParam(from)}`);
  if (to) parts.push(`to=${asParam(to)}`);

  return parts.length ? `?${parts.join("&")}` : "";
};

export const getFinanceSummaryAPI = async (
  from?: Date | null,
  to?: Date | null
): Promise<FinanceSummary> => {
  const response = await createApiCall(
    {
      path: `/v1/reports/finance/summary${buildRangeParams(from, to)}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data;
};

export const getFinanceExpensesAPI = async (
  from?: Date | null,
  to?: Date | null
): Promise<ExpenseBreakdown> => {
  const response = await createApiCall(
    {
      path: `/v1/reports/finance/expenses${buildRangeParams(from, to)}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data;
};

export const getFinanceReceivablesAPI = async (
  from?: Date | null,
  to?: Date | null
): Promise<ReceivablesReport> => {
  const response = await createApiCall(
    {
      path: `/v1/reports/finance/receivables${buildRangeParams(from, to)}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data;
};

export const getFinanceVehiclesAPI = async (
  from?: Date | null,
  to?: Date | null
): Promise<VehicleFinanceRow[]> => {
  const response = await createApiCall(
    {
      path: `/v1/reports/finance/vehicles${buildRangeParams(from, to)}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return response.data;
};
